import styled from 'styled-components';

export const SaveGamesWidgetGamesTitleBox = styled.div`
    text-align: center;
    line-height: normal;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    direction: initial;
    padding: 4px 0;
    color: ${({theme}) => theme.colors.textContrast};
`;
